import React, { useState } from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { isObjectEmpty } from '../../../../../../common/src/legacy/services/objectService';

// Components
import VehicleLookupComponentV2 from '../../../../../../common/src/components/VehicleLookupComponentV2';

// Types
import { Car } from '../../../../../../../types/SMT';
import { CarResponse } from '../../../../../../../types/VehicleResponse';
import QuestionGroupActions from '../../../ui/advisory-flow/components/question-group-components/QuestionGroupActions';
import QuestionGroupAssistantQuestion from '../../../ui/advisory-flow/components/question-group-components/QuestionGroupAssistantQuestion';
import AdvisoryFlowMainContainer from '../../../ui/advisory-flow/components/app-shell/AdvisoryFlowMainContainer';
import { Flex } from '@wegroup/design-system';
import { getBrandFilter } from '../../../../utils/carUtils';
import useAuth from '../../../../../../app/src/features/authentication/hooks/useAuth';
import { isSocialLoginUrl } from '../../../../../../app/src/features/authentication/constants/SocialAuth';

interface Props {
  vehicle: Car | undefined;
  nextSubView: (arg0: string) => void;
  handleChange: (arg0?: Car) => void;
  previousSubView: () => void;
}

const CarSearch: React.FC<React.PropsWithChildren<Props>> = ({
  vehicle,
  handleChange,
  nextSubView,
  previousSubView,
}) => {
  const { t } = useTranslation();
  const [isLoading, setIsLoading] = useState(false);
  const { campaign } = useAuth();
  const params = sessionStorage.getItem('params') || '{}';
  const { brand: brandParam } = JSON.parse(params);

  const mapVehicleApiRespToQuotesAnswer = (vehicle?: CarResponse): Car => {
    return {
      ...vehicle?.domain_car.car,
      images: vehicle?.data.images,
      vehicleChoices: vehicle?.data?.vehicleChoices,
    };
  };

  const handleOnChange = (vehicle?: CarResponse) => {
    if (vehicle) {
      handleChange(mapVehicleApiRespToQuotesAnswer(vehicle));
      nextSubView('vehicleData');
    }
  };

  return (
    <AdvisoryFlowMainContainer data-test-id="ProdFac_CarSearch">
      <QuestionGroupAssistantQuestion
        question={t('Okay, let’s find out what car you want to insure')}
        description={t('Fill in all details about your car')}
      />
      <Flex
        maxW="5xl"
        mx="auto"
        alignItems="flex-start"
        justifyContent="center"
        w="100%"
        flexGrow={1}
        px="4"
        pt="8"
      >
        <StyledVehicleLookupComponentV2
          vehicleChoices={vehicle?.vehicleChoices}
          onChange={handleOnChange}
          setIsLoading={setIsLoading}
          brandFilter={brandParam ? [brandParam] : getBrandFilter(campaign)}
          isCampaign={isSocialLoginUrl}
          categories={['PASSENGER_CAR']}
        />
      </Flex>
      <QuestionGroupActions
        onBack={previousSubView}
        onContinue={() => nextSubView('vehicleData')}
        disabledContinue={
          isLoading || !vehicle?.version || !!isObjectEmpty(vehicle)
        }
      />
    </AdvisoryFlowMainContainer>
  );
};

const StyledVehicleLookupComponentV2 = styled(VehicleLookupComponentV2)`
  width: 100%;
  margin-bottom: 2.4rem;
`;

export default CarSearch;
